module.exports = __webpack_public_path__ + "img/landing-1.9092bbb1.png";